import {
    ROLES,
    PERMISSIONS
} from '@/config/permissions'

export default {
    data: function () {
        return {
            ROLES: ROLES,
            PERMISSIONS: PERMISSIONS
        }
    },

    methods: {
        hasRole(roleName) {
            // Check if role exsits in user roles
            /* if (this.$store.state.users.roles.length) {
                return this.$store.state.users.roles.includes(roleName);
            } */

            if (this.$store.state.users.role == roleName) {
                return true;
            }
            return false
        },

        can(perm, authorID = false) {
            // If user is system/school admin or
            // If authorID id is equal to current userId
            // the permission is always granted
            
            if (this.hasRole(ROLES.SYSTEMADMINS) || this.hasRole(ROLES.SCHOOLADMINS) || this.hasRole(ROLES.TEACHERS) || this.$store.state.users.user.id == authorID) {
                return true;
            }

            // Check if permission exsits in user permissions
            if (this.$store.state.users.permissions.length) {
                return this.$store.state.users.permissions.includes(perm);
            }
            return false;
        },

        canAny(perms) {
            if (!Array.isArray(perms)) {
                return this.can(perms);
            }

            return perms.some(perm => this.can(perm));
        }
    }
}